function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 28.31,
  cy: 28.392,
  r: 22.53,
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.204 47.546c8.155-12.683 8.088-25.419 0-38.128M39.54 47.546c-8.155-12.683-8.088-25.419 0-38.128M21.147 28.97h4.275M20.8 23.308l3.928-.809m-5.083-3.928l3.466-1.387m-5.546-3.234l3.235-1.849m0 22.491l3.928.809m-5.083 3.928l3.466 1.387m-5.546 3.234l3.235 1.849M35.418 28.97h-4.275m4.622-5.662l-3.928-.809m5.083-3.928l-3.466-1.387M39 13.95l-3.235-1.849m0 22.491l-3.928.809m5.083 3.928l-3.466 1.387M39 43.95l-3.235 1.849"
}));

var SvgBaseball = function SvgBaseball(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBaseball, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Baseball.16ee3d4a.svg";
export { ForwardRef as ReactComponent };